import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initSentry } from './lib/sentry';
import './index.css';
import App from './App.tsx';

// Initialise error tracking (GlitchTip-compatible)
initSentry();

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <App />
    </StrictMode>,
);
